import React, { useEffect, useState } from 'react';
import SimpleModal from './SimpleModal';
import PayPalSubscribeButton from './PayPalSubscribeButton';
import { KiddiFitWordmark } from './Brand';
import useUserSubscription from '../hooks/useUserSubscription';

function PremiumUpgradeModal({ isOpen, onClose }) {
  const { isPremium } = useUserSubscription();
  const [isActivating, setIsActivating] = useState(false);
  const [activated, setActivated] = useState(false);

  useEffect(() => {
    if (isActivating && isPremium) setActivated(true);
  }, [isActivating, isPremium]);

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onClose}
      title='Premium Subscription'
      body={
        <>
          <p>
            Access the complete <KiddiFitWordmark /> library and future premium
            courses at the founding member price:
          </p>
          <h2>
            <span style={{ textDecoration: 'line-through', opacity: 0.7 }}>
              $19.99
            </span>{' '}
            $9.99/mo
          </h2>
          <p>We thank you for your support!</p>
          <div style={{ marginTop: 46 }}>
            {!isActivating && !activated && (
              <PayPalSubscribeButton
                onProcessing={() => setIsActivating(true)}
              />
            )}
            {isActivating && !activated && (
              <div style={{ padding: '12px 0', fontWeight: 600 }}>
                Activating Premium... please wait a few seconds.
              </div>
            )}
            {activated && (
              <div style={{ padding: '12px 0', fontWeight: 700 }}>
                Premium Activated!
              </div>
            )}
            <div
              style={{
                color: '#ccc',
                fontSize: 12,
                marginTop: 24,
                marginBottom: 24,
              }}
            >
              Premium features unlock automatically after subscribing. Cancel
              anytime, no questions asked.
            </div>
          </div>
        </>
      }
    />
  );
}

export default PremiumUpgradeModal;
